import { Component, Input } from "@angular/core";

@Component({
  selector: 'lms-markdown',
  templateUrl: './markdown.component.html',
})

export class MarkdownComponent {
  @Input() content: string = '';
}